"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrainingPreviewItem = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const mark_boolean_value_1 = require("../../molecules/mark-boolean-value");
const typography_1 = require("../../shared/typography");
const icons_1 = require("../../atoms/icons");
const TrainingInfoBar_1 = require("./TrainingInfoBar");
const TrainingPreviewItem = ({ label, value, rating, isValueVisible = true, onClick, sportActivities }) => {
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { onClick: onClick, children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(typography_1.H4, { children: label }, void 0) }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", { children: isValueVisible && (0, jsx_runtime_1.jsx)(mark_boolean_value_1.MarkBooleanValue, { value: value }, void 0) }, void 0), (0, jsx_runtime_1.jsx)("div", { children: isValueVisible && ((0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", color: "light-grey", children: (0, TrainingInfoBar_1.ratingValueChecked)(rating || "") }, void 0)) }, void 0), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(typography_1.P, { children: sportActivities }, void 0) }, void 0)] }, void 0)] }, void 0));
};
exports.TrainingPreviewItem = TrainingPreviewItem;
const Wrapper = styled_components_1.default.div `
  align-items: center;
  background-color: ${({ theme }) => theme.colors.whiteBase};
  cursor: pointer;
  justify-content: space-between;
  display: flex;
  padding: ${({ theme }) => `${theme.spacings.xs} 0`};

  p {
    margin-bottom: 0;
  }

  & > div:first-of-type {
    flex: 1;

    & h4 {
      color: ${({ theme }) => theme.colors.greyLighten40};
      font-weight: 400;
    }
  }

  & > div:last-of-type {
    align-items: center;
    display: flex;
    flex: 2;
    justify-content: space-between;

    & > div {
      flex: 1;
    }

    & > div:first-of-type {
      padding-left: 1rem;
    }
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    & > div:last-of-type {
      flex: 0;
      justify-content: flex-end;

      & > div {
        flex: 0;
        margin-left: 1rem;
      }

      & > div:last-of-type p {
        text-align: center;
        width: 1.5rem;
      }
    }
  }
`;
//# sourceMappingURL=TrainingPreviewItem.js.map